export const timezones = [
  "Pacific/Niue",
  "Pacific/Pago_Pago",
  "Pacific/Honolulu",
  "Pacific/Tahiti",
  "America/Adak",
  "Pacific/Marquesas",
  "Pacific/Gambier",
  "America/Anchorage",
  "America/Juneau",
  "America/Metlakatla",
  "America/Nome",
  "America/Sitka",
  "America/Yakutat",
  "Pacific/Pitcairn",
  "America/Los_Angeles",
  "America/Tijuana",
  "America/Vancouver",
  "America/Dawson",
  "America/Dawson_Creek",
  "America/Fort_Nelson",
  "America/Hermosillo",
  "America/Phoenix",
  "America/Whitehorse",
  "America/Boise",
  "America/Cambridge_Bay",
  "America/Chihuahua",
  "America/Denver",
  "America/Edmonton",
  "America/Inuvik",
  "America/Mazatlan",
  "America/Ojinaga",
  "America/Yellowknife",
  "America/Belize",
  "America/Costa_Rica",
  "America/El_Salvador",
  "America/Guatemala",
  "America/Managua",
  "America/Regina",
  "America/Swift_Current",
  "America/Tegucigalpa",
  "Pacific/Galapagos",
  "Pacific/Rarotonga",
  "America/Bahia_Banderas",
  "America/Chicago",
  "America/Indiana/Knox",
  "America/Indiana/Tell_City",
  "America/Matamoros",
  "America/Menominee",
  "America/Merida",
  "America/Mexico_City",
  "America/Monterrey",
  "America/North_Dakota/Beulah",
  "America/North_Dakota/Center",
  "America/North_Dakota/New_Salem",
  "America/Rainy_River",
  "America/Rankin_Inlet",
  "America/Resolute",
  "America/Winnipeg",
  "Pacific/Easter",
  "America/Bogota",
  "America/Cancun",
  "America/Eirunepe",
  "America/Guayaquil",
  "America/Jamaica",
  "America/Lima",
  "America/Panama",
  "America/Rio_Branco",
  "America/Detroit",
  "America/Grand_Turk",
  "America/Havana",
  "America/Indiana/Indianapolis",
  "America/Indiana/Marengo",
  "America/Indiana/Petersburg",
  "America/Indiana/Vevay",
  "America/Indiana/Vincennes",
  "America/Indiana/Winamac",
  "America/Iqaluit",
  "America/Kentucky/Louisville",
  "America/Kentucky/Monticello",
  "America/New_York",
  "America/Nipigon",
  "America/Pangnirtung",
  "America/Port-au-Prince",
  "America/Thunder_Bay",
  "America/Toronto",
  "America/Barbados",
  "America/Boa_Vista",
  "America/Campo_Grande",
  "America/Caracas",
  "America/Cuiaba",
  "America/Guyana",
  "America/La_Paz",
  "America/Manaus",
  "America/Martinique",
  "America/Porto_Velho",
  "America/Puerto_Rico",
  "America/Santo_Domingo",
  "America/Asuncion",
  "America/Glace_Bay",
  "America/Goose_Bay",
  "America/Halifax",
  "America/Moncton",
  "America/Santiago",
  "America/Thule",
  "Atlantic/Bermuda",
  "America/St_Johns",
  "America/Araguaina",
  "America/Argentina/Buenos_Aires",
  "America/Argentina/Catamarca",
  "America/Argentina/Cordoba",
  "America/Argentina/Jujuy",
  "America/Argentina/La_Rioja",
  "America/Argentina/Mendoza",
  "America/Argentina/Rio_Gallegos",
  "America/Argentina/Salta",
  "America/Argentina/San_Juan",
  "America/Argentina/San_Luis",
  "America/Argentina/Tucuman",
  "America/Argentina/Ushuaia",
  "America/Bahia",
  "America/Belem",
  "America/Cayenne",
  "America/Fortaleza",
  "America/Maceio",
  "America/Montevideo",
  "America/Paramaribo",
  "America/Punta_Arenas",
  "America/Recife",
  "America/Santarem",
  "America/Sao_Paulo",
  "Antarctica/Palmer",
  "Antarctica/Rothera",
  "Atlantic/Stanley",
  "America/Miquelon",
  "America/Godthab",
  "America/Noronha",
  "Atlantic/South_Georgia",
  "Atlantic/Cape_Verde",
  "America/Scoresbysund",
  "Atlantic/Azores",
  "Pacific/Kiritimati",
  "Pacific/Apia",
  "Pacific/Fakaofo",
  "Pacific/Enderbury",
  "Pacific/Tongatapu",
  "Pacific/Chatham",
  "Pacific/Auckland",
  "Pacific/Fiji",
  "Asia/Anadyr",
  "Asia/Kamchatka",
  "Pacific/Funafuti",
  "Pacific/Kwajalein",
  "Pacific/Majuro",
  "Pacific/Nauru",
  "Pacific/Tarawa",
  "Pacific/Wake",
  "Pacific/Wallis",
  "Pacific/Norfolk",
  "Antarctica/Casey",
  "Asia/Magadan",
  "Asia/Sakhalin",
  "Asia/Srednekolymsk",
  "Pacific/Bougainville",
  "Pacific/Efate",
  "Pacific/Guadalcanal",
  "Pacific/Kosrae",
  "Pacific/Noumea",
  "Pacific/Pohnpei",
  "Australia/Lord_Howe",
  "Antarctica/Macquarie",
  "Australia/Hobart",
  "Australia/Melbourne",
  "Australia/Sydney",
  "Asia/Ust-Nera",
  "Asia/Vladivostok",
  "Australia/Brisbane",
  "Australia/Lindeman",
  "Pacific/Chuuk",
  "Pacific/Guam",
  "Pacific/Port_Moresby",
  "Australia/Adelaide",
  "Australia/Broken_Hill",
  "Australia/Darwin",
  "Asia/Chita",
  "Asia/Dili",
  "Asia/Jayapura",
  "Asia/Khandyga",
  "Asia/Pyongyang",
  "Asia/Seoul",
  "Asia/Tokyo",
  "Asia/Yakutsk",
  "Pacific/Palau",
  "Australia/Eucla",
  "Asia/Brunei",
  "Asia/Choibalsan",
  "Asia/Hong_Kong",
  "Asia/Irkutsk",
  "Asia/Kuala_Lumpur",
  "Asia/Kuching",
  "Asia/Macau",
  "Asia/Makassar",
  "Asia/Manila",
  "Asia/Shanghai",
  "Asia/Singapore",
  "Asia/Taipei",
  "Asia/Ulaanbaatar",
  "Australia/Perth",
  "Antarctica/Davis",
  "Asia/Bangkok",
  "Asia/Barnaul",
  "Asia/Ho_Chi_Minh",
  "Asia/Hovd",
  "Asia/Jakarta",
  "Asia/Krasnoyarsk",
  "Asia/Novokuznetsk",
  "Asia/Novosibirsk",
  "Asia/Pontianak",
  "Asia/Tomsk",
  "Indian/Christmas",
  "Asia/Yangon",
  "Indian/Cocos",
  "Antarctica/Vostok",
  "Asia/Almaty",
  "Asia/Bishkek",
  "Asia/Dhaka",
  "Asia/Omsk",
  "Asia/Qostanay",
  "Asia/Thimphu",
  "Asia/Urumqi",
  "Indian/Chagos",
  "Asia/Kathmandu",
  "Asia/Colombo",
  "Asia/Kolkata",
  "Antarctica/Mawson",
  "Asia/Aqtau",
  "Asia/Aqtobe",
  "Asia/Ashgabat",
  "Asia/Atyrau",
  "Asia/Dushanbe",
  "Asia/Karachi",
  "Asia/Oral",
  "Asia/Qyzylorda",
  "Asia/Samarkand",
  "Asia/Tashkent",
  "Asia/Yekaterinburg",
  "Indian/Kerguelen",
  "Indian/Maldives",
  "Asia/Kabul",
  "Asia/Baku",
  "Asia/Dubai",
  "Asia/Tbilisi",
  "Asia/Yerevan",
  "Europe/Astrakhan",
  "Europe/Samara",
  "Europe/Saratov",
  "Europe/Ulyanovsk",
  "Indian/Mahe",
  "Indian/Mauritius",
  "Indian/Reunion",
  "Asia/Tehran",
  "Africa/Nairobi",
  "Asia/Baghdad",
  "Asia/Qatar",
  "Asia/Riyadh",
  "Europe/Istanbul",
  "Europe/Kirov",
  "Europe/Minsk",
  "Europe/Moscow",
  "Europe/Simferopol",
  "Europe/Volgograd",
  "Asia/Amman",
  "Asia/Beirut",
  "Asia/Damascus",
  "Asia/Famagusta",
  "Asia/Gaza",
  "Asia/Hebron",
  "Asia/Jerusalem",
  "Asia/Nicosia",
  "Europe/Athens",
  "Europe/Bucharest",
  "Europe/Chisinau",
  "Europe/Helsinki",
  "Europe/Kiev",
  "Europe/Riga",
  "Europe/Sofia",
  "Europe/Tallinn",
  "Europe/Uzhgorod",
  "Europe/Vilnius",
  "Europe/Zaporozhye",
  "Africa/Cairo",
  "Africa/Johannesburg",
  "Africa/Juba",
  "Africa/Khartoum",
  "Africa/Maputo",
  "Africa/Tripoli",
  "Africa/Windhoek",
  "Europe/Kaliningrad",
  "Africa/Ceuta",
  "Europe/Amsterdam",
  "Europe/Andorra",
  "Europe/Belgrade",
  "Europe/Berlin",
  "Europe/Brussels",
  "Europe/Budapest",
  "Europe/Copenhagen",
  "Europe/Gibraltar",
  "Europe/Luxembourg",
  "Europe/Madrid",
  "Europe/Malta",
  "Europe/Monaco",
  "Europe/Oslo",
  "Europe/Paris",
  "Europe/Prague",
  "Europe/Rome",
  "Europe/Stockholm",
  "Europe/Tirane",
  "Europe/Vienna",
  "Europe/Warsaw",
  "Europe/Zurich",
  "Africa/Algiers",
  "Africa/Lagos",
  "Africa/Ndjamena",
  "Africa/Tunis",
  "Africa/Casablanca",
  "Africa/El_Aaiun",
  "Europe/Dublin",
  "Antarctica/Troll",
  "Atlantic/Canary",
  "Atlantic/Faroe",
  "Atlantic/Madeira",
  "Europe/Lisbon",
  "Europe/London",
  "Africa/Abidjan",
  "Africa/Bissau",
  "Africa/Monrovia",
  "Africa/Sao_Tome",
  "America/Danmarkshavn",
  "Atlantic/Reykjavik",
  "UTC",
];
